import React from 'react';
import PropTypes from 'prop-types';
import PrimaryButton from '../../Buttons/PrimaryButton';
import BlankCard from '../../Cards/BlankCard';
import Carousel from '../../Carousel/Carousel';
import Accordion from '../../Accordion/Accordion';
import InquiryForm from '../../Inquiry/InquiryForm';

import airbnbLogo from '../../../../assets/images/airbnb.png';
import vrboLogo from '../../../../assets/images/vrbo.png';
import expediaLogo from '../../../../assets/images/expedia.png';
import bookingLogo from '../../../../assets/images/booking.png';
import evolveLogo from '../../../../assets/images/evolve.png';
import turnkeyLogo from '../../../../assets/images/turnkey.png';
import combo5IphoneAll from '../../../../../app/assets/images/combo-5-iphone-12-all.png';
import comboIpadBasicsDashboard from '../../../../../app/assets/images/combo-ipad-basics-dashboard.png';
import comboMetricsRevenue from '../../../../../app/assets/images/combo-ipad-metrics-revenue.png';
import iPhoneDashboardActive from '../../../../../app/assets/images/iphone-12-dashboard-active.png';
import iPhoneRevenue from '../../../../../app/assets/images/iphone-12-revenue.png';
import iPhoneMetrics from '../../../../../app/assets/images/iphone-12-metrics';
import beachfrontImage from '../../../../assets/images/kaimana_beach.jpg';
import womanImage from '../../../../assets/images/woman.jpg';

export default function MarketingHomePage({ create_inquiry_endpoint }) {
	return (
		<div className="-mb-10 md:-mb-32">
			<section className="bg-hero bg-center bg-fit h-875">
				<div>
					<div className="lg:ml-60 py-4 px-6 md:p-10">
						<h1 className="mt-48 text-5xl text-gray-100 font-semibold md:text-6xl md:mt-48 lg:w-1/2">
							Take the stress out of filing lodging taxes
							<div className="my-4">
								<PrimaryButton
									label="Learn more"
									url="/cart"
									onShowcase={true}
								/>
							</div>
						</h1>
					</div>
				</div>
			</section>
			<section className="container text-center">
				<h2 className="text-5xl py-10 text-center">Introducing Travltax</h2>
				<Carousel
					slideSpeed={12000}
					images={[
						comboIpadBasicsDashboard,
						combo5IphoneAll,
						comboMetricsRevenue
					]}
					mobileImages={[
						iPhoneDashboardActive,
						iPhoneRevenue,
						iPhoneMetrics
					]}
				/>
				<div className="text-center py-16 md:h-70">
					<div className="grid grid-cols-1 md:grid-cols-3">
						<div className="px-5 md:mt-0">
							<i className="icon fas fa-check-circle fa-4x mb-3 text-tt-blue-700 hover:text-tt-blue-700" />
							<div className="text-gray-800">
								<h3 className="text-2xl">Easy to use</h3>
								<p>
									Our mobile-friendly app makes it quick and easy to file your
									Hawaii lodging taxes.
								</p>
							</div>
						</div>
						<div className="px-5 px-4 mt-12 md:mt-0">
							<i className="icon fas fa-bullseye fa-4x mb-3 text-tt-blue-700 hover:text-tt-blue-700" />
							<div className="text-gray-800">
								<h3 className="text-2xl">Servicing Hawaii</h3>
								<p>We remit lodging taxes across the Hawaiian Islands.</p>
							</div>
						</div>
						<div className="px-10 px-4 mt-12 md:mt-0">
							<i className="icon fas fa-heart fa-4x mb-3 text-tt-blue-700 hover:text-tt-blue-700" />
							<div className="text-gray-800">
								<h3 className="text-2xl">Guaranteed results</h3>
								<p className="max-w-sm mx-auto">
									Your lodging taxes will be accurately calculated and remitted
									on time or your money back.
								</p>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section className="container">
				<h2 className="text-5xl p-10 pt-16 text-center">
					Our customers partner with industry leaders
				</h2>
				<div className="p-10 grid grid-cols-1 md:grid-cols-3 place-items-center h-auto md:h-70">
					<img src={airbnbLogo} className="m-5 mx-1 w-52" alt="Airbnb Logo" />
					<img src={vrboLogo} className="m-5 mx-1 w-52" alt="VRBO Logo" />
					<img src={expediaLogo} className="m-5 mx-1 w-52" alt="Expedia Logo" />
					<img
						src={bookingLogo}
						className="m-5 mx-1 object-scale-down w-52"
						alt="Booking Logo"
					/>
					<img
						src={evolveLogo}
						className="m-5 mx-1 object-scale-down w-52"
						alt="Evolve Logo"
					/>
					<img
						src={turnkeyLogo}
						className="m-5 mx-1 object-scale-down w-52"
						alt="Turnkey Logo"
					/>
				</div>
			</section>
			<section className="container mt-6">
				<div className="p-5 md:p-20">
					<div className="text-lg text-center font-light grid place-items-center">
						<div>
							<h4 className="md:text-2xl">
								"Travltax is simply the best solution for calculating and
								remitting my Hawaii lodging taxes."
							</h4>
							<em className="block mt-4 mb-2"> -Regina, Maui</em>
						</div>
						<img
							src={womanImage}
							className="m-5 mx-3 object-scale-down w-48 rounded-full"
							alt="Woman"
						/>
					</div>
				</div>
			</section>
			<section className="bg-gray-50">
				<div className="container px-4 md:px-24">
					<div className="grid grid-cols-1 md:grid-cols-2 pt-24">
						<div>
							<h3 className="text-3xl md:text-5xl mb-6 px-2">
								Your questions, <span className="block">answered</span>
							</h3>
						</div>
						<div className="px-2 md:pl-12">
							<Accordion
								title="Is Travltax right for you?"
								body="Travltax customers want a quick and easy, mobile-friendly app to manage their lodging taxes. Travltax currently collects and remits lodging taxes across the Hawaiian Islands."
							/>
							<Accordion
								title="Does Travltax support other markets beside Hawaii?"
								body="No, currently Travltax only supports Hawaii. However, we are planning to expand to other markets soon. Please drop us a message and we'll be sure to stay in touch."
							/>
							<Accordion
								title="How long does the onboarding process take?"
								body="Generally, it takes two to three weeks and we'll lead you through the process step-by-step."
							/>
							<Accordion
								title="Why should I use Travltax over a competitor?"
								body="Aside from the fact that the founders are really cool guys, the Travltax experience is unmatched. With a best-in-class mobile-friendly app, paying your Hawaii lodging taxes has never been easier."
							/>
						</div>
					</div>
					<div className="grid grid-cols-1">
						<div className="my-24">
							<BlankCard>
								<div className="grid grid-cols-1 lg:grid-cols-2">
									<div>
										<img
											className="rounded-tl rounded-bl"
											src={beachfrontImage}
											alt="Beachfront"
										/>
									</div>
									<div className="px-12">
										<div className="mt-12">
											<span className="block mb-5 text-xl md:text-3xl">
												Do you own or manage a short-term rental property in
												Hawaii?
											</span>
											<span className="block mb-5 text-md md:text-xl">
												Great news! Travltax is launching in Hawaii on January
												1st, 2026! Join our waitlist now for exclusive offers.
											</span>
										</div>
										<div>
											<InquiryForm
												hideTitle={true}
												endpoint={create_inquiry_endpoint}
											/>
										</div>
									</div>
								</div>
							</BlankCard>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
}

MarketingHomePage.propTypes = {
	create_inquiry_endpoint: PropTypes.string.isRequired
};
